import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { TextFieldWrapper } from 'components/Input/TextFieldWrapper';
import { ENTER_EMAIL_FORM_LABELS, ENTER_EMAIL_FORM_NAMES } from 'shared/constants/form-constants';
import { FORMS_BUTTON } from 'shared/constants/buttons-constants';
import { RESPONSE_CODES } from 'shared/constants/validation-constants';
import { useForgotPasswordMutation } from 'redux/api/auth.api';
import { useLoading } from 'shared/hooks/useLoading';
import { TError, ForgotPasswordRequest } from 'shared/types/api.interface';
import { TEnterEmailFormType, EnterEmailFormValidation } from './vatidationSchema';

const fieldsArr = [ENTER_EMAIL_FORM_NAMES.email];

type EnterEmailFormProps = {
  setCurrentEmail: (str: string) => void;
  defaultEmail: string;
};

export const EnterEmailForm = ({ setCurrentEmail, defaultEmail }: EnterEmailFormProps) => {
  const {
    handleSubmit,
    control,
    setError,
    formState: { errors },
  } = useForm<TEnterEmailFormType>({
    defaultValues: {
      [ENTER_EMAIL_FORM_NAMES.email]: defaultEmail,
    },
    resolver: zodResolver(EnterEmailFormValidation),
  });
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  useLoading(isLoading);
  // const captchaValue = useAppSelector(selectCaptcha);

  const catchSubmitError = (errorsArr: TError[]) => {
    fieldsArr.forEach((field) => {
      setError(field, {
        type: 'custom',
        message:
          errorsArr.find(
            (item: TError) => item.attr === field || item.code === RESPONSE_CODES.notFound,
          )?.detail || '',
      });
    });
  };
  // const handleCaptchaChange = (value: any) => dispatch(setCaptcha(value));

  const onSubmit: SubmitHandler<TEnterEmailFormType> = async (data: ForgotPasswordRequest) => {
    try {
      await forgotPassword(data).unwrap();
      setCurrentEmail(data.email);
    } catch (err) {
      catchSubmitError(err?.data?.errors);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', paddingTop: '42px' }}>
      <Stack alignItems="stretch" width="100%">
        <TextFieldWrapper
          name={ENTER_EMAIL_FORM_NAMES.email}
          control={control}
          label={ENTER_EMAIL_FORM_LABELS.email}
          errorMessage={errors.email ? (errors.email?.message as string) : ''}
        />
        <Button
          sx={{ mt: { lg: '56px', md: '24px', sm: '24px', xs: '24px' }, alignSelf: 'center' }}
          variant="fixedSize"
          type="submit"
        >
          {FORMS_BUTTON.enterEmailSubmitButton}
        </Button>
        {/* <Stack sx={{ mt: '20px', alignSelf: 'center' }}>
          <ReCAPTCHA onChange={handleCaptchaChange} sitekey={process.env.REACT_APP_SITE_KEY} />
        </Stack> */}
      </Stack>
    </form>
  );
};
